__turbopack_context__.v({
  "button": "search-item-module-scss-module__RTikIW__button",
  "searchItem": "search-item-module-scss-module__RTikIW__searchItem",
});
